var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultiSelectChemical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "url(#paint0_linear_5336_12888)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.168 17.168H24.168V24.168H17.168V17.168ZM17.168 26.5013H24.168V33.5013H17.168V26.5013ZM17.168 35.8346H24.168V42.8346H17.168V35.8346ZM26.5013 21.8346H42.8346V19.5013H26.5013V21.8346ZM42.8346 31.168H26.5013V28.8346H42.8346V31.168ZM26.5013 40.5013H42.8346V38.168H26.5013V40.5013Z",
    fill: "url(#paint1_linear_5336_12888)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5336_12888",
    x1: 0,
    y1: 0,
    x2: 60,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB421"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA5A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5336_12888",
    x1: 30.0013,
    y1: 17.168,
    x2: 30.0013,
    y2: 42.8346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.9
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiSelectChemical);
export default __webpack_public_path__ + "static/media/multi-select-chemical.9a3eefa50e6af54d55a4f2ed10b88494.svg";
export { ForwardRef as ReactComponent };